import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../redux/actions/loadingAction";
import { logout } from "../../../redux/actions/logoutAction";
import { useHistory } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { Row, Col } from "react-bootstrap";

import * as API from "../../../utils/apis";

import BoxCard from "../../../components/BoxCard";
import InputText from "../../../components/InputText";
import Breadcrumb from "../../../components/Breadcrumb";
import DataTableNodata from "../../../components/DataTableNodata";
import DataTable from "../../../components/DataTable";
import ModalGFMFarmerType from "../../../components/Data_Management/Modal.GFMFarmerType";

const MySwal = withReactContent(Swal);

function MenuSystem() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.login.result);
  const statusCheck = useSelector((state) => state.statusCheck);
  const breadcrumbPath = [
    { path: "/home", name: "หน้าหลัก" },
    {
      path: "/data-manage/web-settings/news",
      name: "บริหารจัดการข้อมูลส่วนกลาง",
    },
    { path: "/data-manage/master-data/animal-type", name: "Master Data" },
    { path: "active", name: "ประเภทเกษตรกรมาตรฐาน GFM" },
  ];

  const initialForm = {
    //data to save
    gfmId: "",
    search: "",
    animalTypeId: "",
    minorValue: "",
    smallValue: "",
    mediumValue: "",
    statusId: "",

    idEdit: "",
    mode: "",

    limit: 10,
    page: 1,
    totalPages: 1,
    sortDir: "DESC",
    sortBy: "id",
    totalElements: 0,
    numberOfElements: 0,

    headTitle: [
      {
        name: "ลำดับ",
        width: "50px",
        sortFlg: false,
      },
      {
        sortBy: "animalTypeName",
        name: "ชนิดสัตว์",
        sortFlg: true,
      },
      {
        sortBy: "statusId",
        name: "สถานะ",
        sortFlg: true,
      },
      {
        name: "จัดการ",
        sortFlg: false,
      },
    ],
  };

  const [form, setForm] = useState(initialForm);
  //Menu
  const [showMenu, setShowMenu] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const [isClearSearch, setIsClearSearch] = useState(false);

  useEffect(() => {
    getGFM();
  }, [form.limit, form.page, form.sortBy, form.sortDir, isClearSearch]);

  const getGFM = async () => {
    dispatch(loading(true));
    try {
      const response = await API.getGFMFarmerType(
        form.gfmId,
        form.statusId,
        form.search,
        form.sortBy,
        form.sortDir,
        form.page,
        form.limit
      );
      const data = await response?.data;
      let menuArray = [];
      if (response.status === 200) {
        data.content.filter((element) => {
          menuArray.push({
            id: element.id,
            animalTypeId: element.animalTypeId,
            animalTypeName: element.animalTypeName,
            statusId: element.statusId,
          });
        });
        setMenuList(menuArray);
        dispatch(loading(false));
        setForm({
          ...form,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          numberOfElements: data.numberOfElements,
        });
      }
    } catch (error) {
      dispatch(loading(false));
      if (error.response && error.response.status === 401) {
        dispatch(logout({ history }));
      }
      console.log(error);
    }
  };

  const getFilter = (type, isChange1, isChange2) => {
    if (type === "page") {
      setForm({
        ...form,
        page: isChange1,
      });
    } else if (type === "limit") {
      setForm({
        ...form,
        page: 1,
        limit: isChange1,
      });
    } else if (type === "filter") {
      setForm({
        ...form,
        sortBy: isChange1,
        sortDir: isChange2,
        page: 1,
      });
    }
  };

  const getStatusColor = (idStatus) => {
    let statusColor;
    if (statusCheck && statusCheck.length > 0) {
      statusCheck.map((item, index) => {
        if (item.id === idStatus) {
          statusColor = (
            <div className="d-flex justify-content-center">
              <div
                style={{ background: item.color }}
                className="box-status font14 px-4 text-center text-white"
              >
                <span>{item.status}</span>
              </div>
            </div>
          );
        }
      });
    }
    return statusColor;
  };

  const buttonAddMenu = () => {
    return (
      <div className="d-flex justify-content-end ">
        <button
          className="btn btn-add text-white"
          onClick={() => toAddMenu()}
          disabled={user?.userGroup.mcreate === "n"}
        >
          <i className="fas fa-plus mr-1 "></i>เพิ่ม
        </button>
      </div>
    );
  };

  const toSearch = async () => {
    setForm({ ...form, page: 1 });
    setIsClearSearch(!isClearSearch);
  };

  const clearSearch = () => {
    setForm(initialForm);
    setIsClearSearch(!isClearSearch);
  };
  const buttonSearch = () => {
    return (
      <>
        <button className="btn btn-danger mr-2" onClick={() => clearSearch()}>
          ล้างข้อมูล
        </button>
        <button className="btn btn-success" onClick={() => toSearch()}>
          ค้นหา
        </button>
      </>
    );
  };

  const toAddMenu = () => {
    setForm({ ...form, mode: "add", idEdit: "" });
    setShowMenu(true);
  };

  const editModalMenu = (id) => {
    setForm({ ...form, mode: "edit", idEdit: id });
    setShowMenu(true);
  };

  const delGFMFarmer = async (id) => {
    MySwal.fire({
      text: `ยืนยันที่จะลบ `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await API.deleteGFMFarmerType(id);
          if (response?.status === 200) {
            MySwal.fire({
              text: `ลบสำเร็จ`,
              icon: "success",
              confirmButtonText: "ตกลง",
            }).then(async (result) => {
              await getGFM();
            });
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const addSaveMenu = (data) => {
    const dataGFM = {
      animalTypeId: data.gfmFarmerType.animalTypeId,
      minorValue: data.gfmFarmerType.minorValue,
      smallValue: data.gfmFarmerType.smallValue,
      mediumValue: data.gfmFarmerType.mediumValue,
      statusId: data.gfmFarmerType.statusId,
    };

    MySwal.fire({
      text: `ต้องการบันทึก `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response =
            data.mode === "add"
              ? await API.saveGFMFarmerType(dataGFM)
              : await API.updateGFMFarmerType(
                  data.gfmFarmerType.gfmId,
                  dataGFM
                );
          if (response?.status === 200) {
            setShowMenu(false);
            await getGFM();
          }
        } catch (error) {
          if (error.response && error.response.status === 400) {
            MySwal.fire({
              text: `ชนิดสัตว์ซ้ำ กรุณาเลือกชนิดสัตว์ใหม่`,
              icon: "warning",
              showCloseButton: true,
              confirmButtonText: "ตกลง",
            });
          }
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const renderTableMenu = (data) => {
    if (data.length > 0) {
      return data.map((item, i) => (
        <tr
          key={i + item.animalTypeId + item.statusId + item.id}
          className="text-center"
        >
          <td>{form.limit * (form.page - 1) + (i + 1)}</td>
          <td>{item.animalTypeName || "-"}</td>
          <td>{getStatusColor(item.statusId) || "-"}</td>
          <td>
            <div className="d-flex justify-content-center ">
              <button
                className="btn btn-add mr-2 "
                onClick={() => editModalMenu(item.id)}
                disabled={
                  user?.userGroup.mupdate === "n" &&
                  user?.userGroup.mview === "n"
                }
              >
                <img className="icon-btn" src="/svg/btn-edit.svg" alt="edit" />
              </button>
              <button
                className="btn btn-del mr-2 "
                onClick={() => delGFMFarmer(item.id)}
                disabled={user?.userGroup.mdelete === "n"}
              >
                <img className="icon-btn " src="/svg/btn-del.svg" alt="del" />
              </button>
            </div>
          </td>
        </tr>
      ));
    } else {
      return <DataTableNodata colSpan={4} />;
    }
  };

  return (
    <div className=" ">
      <div className="pl-4 bg-white ml30 d-flex">
        <div className="mr-auto p-2 ">
          <Breadcrumb data={breadcrumbPath} />
        </div>
      </div>

      <div className="bg-gray-light ">
        <div className="px-4 pt-3 container-fixed-footer ">
          <BoxCard classNameBox="" title="ตัวกรอง" headRight={buttonSearch()}>
            <Row>
              <Col lg={2} md={6} sm={12} xs={12}>
                <InputText
                  type="text"
                  title="ชนิดสัตว์"
                  idName="title"
                  value={form.search}
                  star={false}
                  placeholder="โปรดระบุ"
                  classLabel="normal"
                  handleChange={(value) => {
                    setForm({ ...form, search: value });
                  }}
                />
              </Col>
            </Row>
          </BoxCard>

          <BoxCard
            title="รายการประเภทเกษตรกรมาตรฐาน GFM"
            classNameBox="mt-4"
            headRight={buttonAddMenu()}
          >
            <DataTable
              headColumns={form.headTitle}
              totalPages={form.totalPages}
              page={form.page}
              limit={form.limit}
              sortDir={form.sortDir}
              sortBy={form.sortBy}
              getLimit={(limit) => getFilter("limit", limit)}
              getFilter={(sortBy, sortDir) =>
                getFilter("filter", sortBy, sortDir)
              }
              getPage={(page) => getFilter("page", page)}
              totalItems={form.totalElements}
              numberOfItems={form.numberOfElements}
              isClear={isClearSearch}
            >
              {renderTableMenu(menuList)}
            </DataTable>
          </BoxCard>
          {showMenu && (
            <ModalGFMFarmerType
              show={showMenu}
              close={() => setShowMenu(false)}
              save={(value) => addSaveMenu(value)}
              mode={form.mode}
              idEdit={form.idEdit}
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default MenuSystem;
